export default {
      id: "flex-flexDirection-row-reverse-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexDirection-row-reverse-usage",
      toString: function () {
        return this.url;
      }
    }